export class Constants {
    static routes: Array<string> = [
        "About",
        "Skills",
        "Works",
        "Contact",
    ]
}